<template>
  <div class="app-footer">
    <el-row
      :gutter="30"
      class="container"
    >
      <el-col :span="6">
        <h5 class="title">关于心晴门诊</h5>
        <p>心晴门诊隶属心晴集团，是一个专业的精神心理专科门诊，致力于提供便捷高效的预约服务和专业贴心的诊疗服务。</p>
      </el-col>
      <el-col :span="6">
        <div class="mb-def">
          <h5 class="title">门诊地址</h5>
          <p>广州市荔湾区中山七路51号富邦中心商场三楼312-313</p>
        </div>
        <div class="mb-def">
          <h5 class="title">营业时间</h5>
          <p>09:00-18:00 (节假日除外)</p>
        </div>
        <div class="mb-def">
          <h5 class="title">预约热线</h5>
          <p>020-82382600</p>
        </div>
      </el-col>
      <el-col :span="7">
        <div class="mb-def">
          <h5 class="title">昭阳医生APP</h5>
          <p>昭阳医生App是心晴集团旗下的在线医疗平台，可以为患者提供复诊、随访、开药等服务。</p>
        </div>
        <div style="width: 150px">
          <img
            src="~@/assets/images/zy_doctor_app_code.png"
            alt="昭阳医生APP二维码"
          >
          <p class="mt-def-small tc">扫描二维码下载应用</p>
        </div>
      </el-col>
      <el-col :span="5">
        <h5 class="title">心晴门诊公众号</h5>
        <div style="width: 150px">
          <img
            src="~@/assets/images/xqmz_wx_code.png"
            alt="心晴门诊公众号二维码"
          >
          <p class="mt-def-small tc">关注心晴门诊公众号</p>
        </div>
      </el-col>
    </el-row>
    <h5 class="title mt-def-half">友情链接</h5>
    <ul class="blogroll-area clearfix">
      <li
        v-for="(b, idx) of blogroll"
        :key="idx"
        class="blogroll-item"
      ><a
          :href="b.link"
          target="_block"
        >{{ b.label }}</a></li>
    </ul>
    <p class="copyright tc text-dark mt-def fs-12">Copyriht©2018{{companyName}}.All Rights Reserve.</p>
    <div class="tc">
      <a class="fs-12" href="https://beian.miit.gov.cn" target="_blank">{{keepRecord}}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-footer',
  data() {
    return {
      blogroll: [
        {
          label: '昭阳医生',
          link: 'https://www.zhaoyang120.com/welcome/index.html',
          keepRecord:'',
          companyName:''
        }
      ]
    }
  },
  created() {
    this.keepRecord = '粤ICP备15089598号'
    this.companyName = '心晴门诊（广州）有限公司'
    // if (window.location.host === 'www.zhaoyang120.cn') {
    //   this.keepRecord = '粤ICP备15089598号-2'
    //   this.companyName = '昭阳健康（广州）科技有限公司'
    // } else {
    //   this.keepRecord = '粤ICP备17162322号-1'
    //   this.companyName = '心晴门诊（广州）有限公司'
    // }
  }
}
</script>

<style lang='less' scoped>
@import '~variables.less';
.app-footer {
  padding: @gutter 5%;
  background: #f1eff0;

  .container {
    padding-bottom: @gutter;
    font-size: 14px;
    border-bottom: 1px solid #b2b2b2;
  }

  .title {
    margin-bottom: @gutter / 4;
  }

  .blogroll-item {
    float: left;
    margin-right: @gutter;
    a:hover {
      color: @color-primary;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/app-footer.vue